import {metadaApi} from '@dms/api/base';

import {
  DeleteRmaRequestItemsRequest,
  DeleteRmaRequestItemsRequestSchema,
  DeleteRmaRequestItemsResponse,
  DeleteRmaRequestItemsResponseSchema,
  GetRmaRequestRequest,
  GetRmaRequestRequestSchema,
  GetRmaRequestResponse,
  GetRmaRequestResponseSchema,
  PatchRmaRequestRequest,
  PatchRmaRequestRequestSchema,
  PatchRmaRequestResponse,
  PatchRmaRequestResponseSchema,
  PostRmaRequestRequest,
  PostRmaRequestRequestSchema,
  PostRmaRequestResponse,
  PostRmaRequestResponseSchema,
} from './types';

export const metadaWarehouseRmaRequestApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getRmaRequest: build.query<GetRmaRequestResponse, GetRmaRequestRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/rma-request/${queryArg.rmaRequestId}`,
        method: 'GET',
        queryArg,
      }),
      extraOptions: {
        requestSchema: GetRmaRequestRequestSchema,
        responseSchema: GetRmaRequestResponseSchema,
      },
    }),
    postRmaRequest: build.mutation<PostRmaRequestResponse, PostRmaRequestRequest>({
      query: (queryArg) => ({
        url: 'warehouse/v1/rma-request',
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      extraOptions: {
        requestSchema: PostRmaRequestRequestSchema,
        responseSchema: PostRmaRequestResponseSchema,
      },
    }),
    patchRmaRequest: build.mutation<PatchRmaRequestResponse, PatchRmaRequestRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/rma-request/${queryArg.rmaRequestId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      // The PATCH response is the whole header, so it replaces the cached GET result
      // without a refetch and without a new cache tag type in the base API.
      // A failed PATCH is reported by the caller's unwrap(), so the cache stays as it was.
      onQueryStarted: (queryArg, {dispatch, queryFulfilled}) =>
        queryFulfilled
          .then(({data}) => {
            dispatch(
              metadaWarehouseRmaRequestApi.util.upsertQueryData(
                'getRmaRequest',
                {rmaRequestId: queryArg.rmaRequestId},
                data
              )
            );
          })
          .catch(() => undefined),
      extraOptions: {
        requestSchema: PatchRmaRequestRequestSchema,
        responseSchema: PatchRmaRequestResponseSchema,
      },
    }),
    deleteRmaRequestItems: build.mutation<
      DeleteRmaRequestItemsResponse,
      DeleteRmaRequestItemsRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/rma-request/${queryArg.rmaRequestId}/items`,
        method: 'DELETE',
        body: queryArg.body,
        queryArg,
      }),
      // Removing items changes the header's modifiedBy / modifiedAt, so the header is refetched.
      onQueryStarted: (queryArg, {dispatch, queryFulfilled}) =>
        queryFulfilled
          .then(() => {
            dispatch(
              metadaWarehouseRmaRequestApi.endpoints.getRmaRequest.initiate(
                {rmaRequestId: queryArg.rmaRequestId},
                {subscribe: false, forceRefetch: true}
              )
            );
          })
          .catch(() => undefined),
      extraOptions: {
        requestSchema: DeleteRmaRequestItemsRequestSchema,
        responseSchema: DeleteRmaRequestItemsResponseSchema,
      },
    }),
  }),
});

export const {
  useGetRmaRequestQuery,
  usePostRmaRequestMutation,
  usePatchRmaRequestMutation,
  useDeleteRmaRequestItemsMutation,
} = metadaWarehouseRmaRequestApi;
